module.exports = __webpack_public_path__ + "img/preview_check.ac2e9df1.png";